<template>
  <div>
    <Card>
      <tables border search-place="bottom" v-model="tableData" :columns="columns"/>
      <Drawer
        :title="changeTitle"
        v-model="change"
        width="667"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="75" :rules="ruleValidate">
          <form-item label="流程名称" prop="name">
            <i-input v-model="formItem.name" placeholder=""></i-input>
          </form-item>
          <form-item label="审批用户" prop="users">
            <transfer
              :data="no_select_user"
              :target-keys="formItem.users"
              :list-style="listStyle"
              @on-change="userChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
            <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import { GetALLUsers } from '@/api/user'
import { getSteps, changeStep } from '@/api/step'
export default {
  name: 'step-manage',
  components: {
    Tables
  },
  data () {
    return {
      defaultIndex: 'menuPerm',
      change: false,
      count: 1,
      size: 10,
      page: 1,
      changeTitle: '添加角色',
      columns: [
        { title: '流程名称', key: 'name', align: 'center', minWidth: 110 },
        { title: '审批用户', key: 'users_name', align: 'center', minWidth: 200 },
        {
          title: '操作',
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '分配用户')
            ])
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      formItem: {
        id: 0,
        name: '',
        users: []
      },
      no_select_user: [],
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        name: [
          { required: true, message: '流程名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    this.getStepsList()
    this.getNoSelectUser()
  },
  methods: {
    edit (params) {
      this.formItem.id = params.row.id
      this.formItem.name = params.row.name
      this.formItem.users = params.row.users
      this.change = true
      this.changeTitle = params.row.name + ' --> 分配用户'
    },
    handleSubmit (name) {
      // let that = this.formItem
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          changeStep(this.formItem, this.formItem.id).then(res => {
            this.$Notice.success({ title: '操作成功！' })
            this.change = false
            this.getStepsList()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
        this.changeLoadingShow = false
      })
    },
    drawerClose () {
      let that = this.formItem
      that.id = 0
      that.name = ''
      that.users = []
    },
    drawerClosePermissions () {
      let that = this.formItem
      that.id = 0
      that.name = ''
      that.users = []
    },
    getStepsList () {
      getSteps().then(res => {
        this.tableData = res.data
      })
    },
    userChange (newTargetKeys) {
      this.formItem.users = newTargetKeys
    },
    getNoSelectUser () {
      let that = this
      that.no_select_user = []
      GetALLUsers().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            if (result[i].name) {
              that.no_select_user.push({
                key: result[i].id,
                label: result[i].name
              })
            } else {
              that.no_select_user.push({
                key: result[i].id,
                label: result[i].username
              })
            }
          }
        }
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
